import { render, staticRenderFns } from "./palvelukuvaus.vue?vue&type=template&id=8a98cc12&"
import script from "./palvelukuvaus.vue?vue&type=script&lang=js&"
export * from "./palvelukuvaus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports